import DS from 'ember-data';
import { dataUrlToFile } from './uploads';

export enum UploadStatus {
  Pending = 'pending',
  Uploading = 'uploading',
  Success = 'success',
  Error = 'error',
}

export type ErrorMessage = {
  message: string;
};

export type FileUploadMeta = {
  file: File;
  folderId: string | null;
  status: UploadStatus;
  errorMessages?: ErrorMessage[];
};

export type FileUploadMetaSimple = {
  file: {
    name: string;
    type: string;
    size: number;
  };
  folderId?: string | null;
  status: UploadStatus;
  errorMessages?: ErrorMessage[];
};

export async function createAssetRecord(name: string, dataUrl: string, store: DS.Store) {
  let file = await dataUrlToFile(name, dataUrl);
  let newAsset = store.createRecord('asset', { name: file.name, size: file.size });
  let response = await newAsset.upload(file);

  return response?.asset;
}
